<template lang="html">
	<div class="chat clearfix" :class="{ active: user.selected }">
		<img :src="user.profile" alt="" class="icon-box f-l" />
		<div class="content-box f-l">
			<div class="top clearfix">
				<div class="title f-l">{{ user.name || user.user_type }}</div>
				<div class="date f-r">{{ moment(user.time).fromNow() }}</div>
			</div>
			<div class="bottom clearfix">
				<div class="txt f-l">{{ user.last_message }}</div>
				<div class="count f-r">{{ user.count }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			default: function () {
				return {
					name: 'Brian Mbunde',
					last_message:
						'We are eager to get a reply from you with regards to the purchase made on 12th Jan 2015',
					time: 'Fri, 27 Mar 2020 11:12:43 GMT',
					count: 3,
					profile: '/img/avatars/2.png',
					selected: true,
				};
			},
		},
	},
	data() {
		return {
			utils,
			moment,
		};
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.chat.active {
	background: #edf8ff;
	border: solid 1px #e9edf0;

	.txt {
		font-size: 12px !important;
	}
}
.chat:first-child {
	margin: 0 0 10px 0;
}
.chat {
	padding: 22px 15px;
	border-radius: 3px;
	border-bottom: solid 1px #f5f9fb;
	background: var(--white);
	margin: 10px 0;
	position: relative;
	cursor: pointer;

	.count {
		background: #001f5f78;
		color: var(--white);
		font-size: 12px;
		line-height: 14px;
		border-radius: 2px;
		font-weight: 600;
		padding: 2px 5px;
		margin: 4px 0 0 0;
	}
	.content-box {
		width: calc(100% - 65px);

		.title {
			color: #3d4661;
			font-weight: 600;
			font-size: 14px;
		}
		.txt {
			color: #646f79;
			font-size: 13px;
			position: absolute;
			width: calc(100% - 125px);
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
		.date {
			color: #646f79;
			font-size: 13px;
			font-weight: 600;
		}
	}
	.icon-box {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin: 0 15px 0 0;
	}
}
</style>
